var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14.297,
    viewBox: "0 0 18 14.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_12_5",
    "data-name": "Component 12 \\u2013 5",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-slash-fill",
    transform: "translate(0 -4.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M12.139,17.338l-1.816-1.817a3.937,3.937,0,0,1-5.034-5.033L2.971,8.17A15.247,15.247,0,0,0,0,11.812S3.375,18,9,18a7.908,7.908,0,0,0,3.138-.662ZM5.861,6.286A7.906,7.906,0,0,1,9,5.625c5.625,0,9,6.188,9,6.188a15.322,15.322,0,0,1-2.971,3.642L12.71,13.135A3.937,3.937,0,0,0,7.676,8.1L5.861,6.287Z",
    transform: "translate(0 -0.961)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M12.4,14.788a2.813,2.813,0,0,0,3.182,3.183L12.4,14.788Zm5.569.8L14.789,12.4a2.813,2.813,0,0,1,3.183,3.182Z",
    transform: "translate(-6.187 -4.335)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M17.2,18,3.7,4.5l.8-.8L18,17.2Z",
    transform: "translate(-1.852)",
    fill: "#74613c",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.90d731300ec1d98e6b7e37d1fe3d2379.svg";
export { ForwardRef as ReactComponent };